import { onMounted, onBeforeUnmount, ref, reactive, watch } from 'vue';
import { useHomeStore } from "../../../store/home"; //引入home仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { useRouter, useRoute } from "vue-router";
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/effect-fade/effect-fade.min.css'; //引入轮播样式-

import 'swiper/modules/pagination/pagination.min.css';
import { it } from 'element-plus/lib/locale';
export default {
  name: 'Mission',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  setup: function setup() {
    var store = useHomeStore();
    var router = useRouter();
    var route = useRoute();
    return {};
  }
};